import usePressTracing from '@atlassian/react-ufo/use-press-tracing';

export default usePressTracing;
